import React from "react";
import { Form } from "react-bootstrap";
import { Search } from "@material-ui/icons";
import PhoneNumber from "./../../../Common/phoneNumber";
import moment from "moment";

class DiscussionList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeThread: 0,
      threadlist: []
    };
  }

  componentWillReceiveProps(nextProps, nextStates) {
    if (this.props.threadList !== undefined) {
      this.setState({ threadlist: this.props.threadList });
    }
  }

  click = () => {
    this.props.DiscussionListMethod(0);
  };

  /**
   * @desc load message using identifier and value
   * identifier - id, mobile, email
   * value - value of identifier
   * use of identifier - as task is having text and email to field which can have either system user selection or custom mobile number
   * So if system user is in discussion, use id
   * if custom email, use email as identifier
   * if custom mobile, use mobile as identifier
   */
  loadMessages = (identifier, value, activeThread, thread) => {
    this.setState({ activeThread: activeThread });
    this.props.DiscussionListMethod(0);
    this.props.getMessageList(identifier, value, thread);
  };

  /**
   * @desc search contacts list by name
   * @param {*} param 
   */
  search(param) {
    let threadlist = this.props.threadList.filter(e => {
      return (
        e.firstname.toLowerCase().includes(param.trim().toLowerCase()) ||
        e.lastname.toLowerCase().includes(param.trim().toLowerCase())
      );
    });
    this.setState({ threadlist });
  }

  render() {

    return (
      <div className="discussion-list">
        <div className="discussion-list-search">
          <div className="page-head-row-small">
            <div className="icon-wrapper">
              <Form.Control
                type="text"
                className="form-control-head"
                placeholder="Search by Name"
                onChange={e => {
                  this.search(e.target.value);
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </div>
        </div>
        <div className="discussion-list-inner">

          {this.state.threadlist.map((thread, i) => {
            return (
              <div
                key={"contact-" + i}
                className={
                  i == this.state.activeThread
                    ? "discussion-list-single active"
                    : "discussion-list-single"
                }
                onClick={() => {
                  let identifier = "mobile";
                  let value = thread.mobileNumber;

                  if (thread._id !== undefined && thread._id !== "") {
                    identifier = "id";
                    value = {
                      email: thread.email.address,
                      mobile: thread.mobileNumber
                    };
                  } else if (thread.email !== undefined && thread.email.address !== "") {
                    identifier = "email";
                    value = thread.email.address;
                  }

                  this.loadMessages(identifier, value, i, thread);
                }}
              >
                <div className="info">
                  <h4 className="title font-16 color-blue-3">
                    {thread._id !== "" ? (
                      thread.firstname +
                      (thread.lastname ? " " + thread.lastname : "")
                    ) : thread.mobileNumber !== undefined ? (
                      <PhoneNumber phoneNumber={thread.mobileNumber} />
                    ) : (
                      thread.email.address
                    )}
                  </h4>

                  {!!thread.roles && (
                    <p className="color-grey-1 font-14">
                      {thread.roles.join(", ")}{" "}
                    </p>
                  )}

                  <p className="desc color-grey-1 font-14">
                    {!!thread.description && thread.description !== undefined?thread.description
                      .replace(/<[^>]*>?/gm, "")
                      .replace(/\&nbsp;/g, " "):""}{" "}
                  </p>
                </div>
                <div className="timestamp">
                  <span className="badge">
                    {thread.unreadCount !== 0 ? thread.unreadCount : ""}
                  </span>
                  <span className="time color-grey-1">
                    {thread.receiveTime !== null
                      ? moment(thread.receiveTime)
                          .local()
                          .format("hh:mm A")
                      : ""}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default DiscussionList;
